export enum MyEmergencyPlanStatus {
  NotStarted,
  InProgress,
  Completed,
  ViewingPlan,
  Editing,
}
